import { Option } from 'mk2/apps/blogs/components/MyProducts';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { ProfileProductType } from 'mk2/schemas';
import { Action } from 'redux';

export interface SuggestedStrollerOption {
    value: string | number;
    label: string;
    isDisabled?: boolean;
}

export interface ProfileProductsRemoveProductApiAction extends Action {
    readonly username: string;
    readonly productId: number;
    readonly productType: ProfileProductType;
}

export const PROFILE_PRODUCTS_REMOVE_PRODUCT_API_REQUEST = 'PROFILE_PRODUCTS_REMOVE_PRODUCT_API_REQUEST';

export interface ProfileProductsRemoveProductApiRequestAction
    extends ProfileProductsRemoveProductApiAction,
        APIRequestAction {
    readonly type: typeof PROFILE_PRODUCTS_REMOVE_PRODUCT_API_REQUEST;
}

export const PROFILE_PRODUCTS_REMOVE_PRODUCT_API_SUCCESS = 'PROFILE_PRODUCTS_REMOVE_PRODUCT_API_SUCCESS';

export interface ProfileProductsRemoveProductApiSuccessAction extends ProfileProductsRemoveProductApiAction {
    readonly type: typeof PROFILE_PRODUCTS_REMOVE_PRODUCT_API_SUCCESS;
}

export const PROFILE_PRODUCTS_REMOVE_PRODUCT_API_FAILURE = 'PROFILE_PRODUCTS_REMOVE_PRODUCT_API_FAILURE';

export interface ProfileProductsRemoveProductApiFailureAction
    extends ProfileProductsRemoveProductApiAction,
        APIFailureAction {
    readonly type: typeof PROFILE_PRODUCTS_REMOVE_PRODUCT_API_FAILURE;
}

export const profileProductsRemoveProductApi = {
    request: (
        username: string,
        productType: ProfileProductType,
        productId: number,
    ): ProfileProductsRemoveProductApiRequestAction => ({
        type: PROFILE_PRODUCTS_REMOVE_PRODUCT_API_REQUEST,
        username,
        productType,
        productId,
    }),
    success: (
        username: string,
        productType: ProfileProductType,
        productId: number,
    ): ProfileProductsRemoveProductApiSuccessAction => ({
        type: PROFILE_PRODUCTS_REMOVE_PRODUCT_API_SUCCESS,
        username,
        productType,
        productId,
    }),
    failure: (
        username: string,
        productType: ProfileProductType,
        productId: number,
        error: any,
    ): ProfileProductsRemoveProductApiFailureAction => ({
        type: PROFILE_PRODUCTS_REMOVE_PRODUCT_API_FAILURE,
        username,
        productType,
        productId,
        error,
    }),
};

export const PROFILE_PRODUCTS_REMOVE_PRODUCT = 'PROFILE_PRODUCTS_REMOVE_PRODUCT';

export interface ProfileProductsRemoveProductAction extends ProfileProductsRemoveProductApiAction {
    readonly type: typeof PROFILE_PRODUCTS_REMOVE_PRODUCT;
}

export const profileProductsRemoveProduct = (
    username: string,
    productType: ProfileProductType,
    productId: number,
): ProfileProductsRemoveProductAction => ({ type: PROFILE_PRODUCTS_REMOVE_PRODUCT, username, productType, productId });

export interface ProfileProductsAddProductApiAction extends Action {
    readonly username: string;
    readonly productId: number;
    readonly productType: ProfileProductType;
}

export const PROFILE_PRODUCTS_ADD_PRODUCT_API_REQUEST = 'PROFILE_PRODUCTS_ADD_PRODUCT_API_REQUEST';

export interface ProfileProductsAddProductApiRequestAction
    extends ProfileProductsAddProductApiAction,
        APIRequestAction {
    readonly type: typeof PROFILE_PRODUCTS_ADD_PRODUCT_API_REQUEST;
}

export interface ProfileProductsAddProductApiNormalizedResponse extends NormalizedResponse {
    readonly result: {
        // TODO: Refactor to be more generic product
        stroller: number;
    };
}

export const PROFILE_PRODUCTS_ADD_PRODUCT_API_SUCCESS = 'PROFILE_PRODUCTS_ADD_PRODUCT_API_SUCCESS';

export interface ProfileProductsAddProductApiSuccessAction
    extends ProfileProductsAddProductApiAction,
        APISuccessAction<ProfileProductsAddProductApiNormalizedResponse> {
    readonly type: typeof PROFILE_PRODUCTS_ADD_PRODUCT_API_SUCCESS;
}

export const PROFILE_PRODUCTS_ADD_PRODUCT_API_FAILURE = 'PROFILE_PRODUCTS_ADD_PRODUCT_API_FAILURE';

export interface ProfileProductsAddProductApiFailureAction
    extends ProfileProductsAddProductApiAction,
        APIFailureAction {
    readonly type: typeof PROFILE_PRODUCTS_ADD_PRODUCT_API_FAILURE;
}

export const profileProductsAddProductApi = {
    request: (
        username: string,
        productType: ProfileProductType,
        productId: number,
    ): ProfileProductsAddProductApiRequestAction => ({
        type: PROFILE_PRODUCTS_ADD_PRODUCT_API_REQUEST,
        username,
        productType,
        productId,
    }),
    success: (
        username: string,
        productType: ProfileProductType,
        productId: number,
        response: ProfileProductsAddProductApiNormalizedResponse,
    ): ProfileProductsAddProductApiSuccessAction => ({
        type: PROFILE_PRODUCTS_ADD_PRODUCT_API_SUCCESS,
        username,
        productType,
        productId,
        response,
    }),
    failure: (
        username: string,
        productType: ProfileProductType,
        productId: number,
        error: any,
    ): ProfileProductsAddProductApiFailureAction => ({
        type: PROFILE_PRODUCTS_ADD_PRODUCT_API_FAILURE,
        username,
        productType,
        productId,
        error,
    }),
};

export const PROFILE_PRODUCTS_ADD_PRODUCT = 'PROFILE_PRODUCTS_ADD_PRODUCT';

export interface ProfileProductsAddProductAction extends ProfileProductsAddProductApiAction {
    readonly type: typeof PROFILE_PRODUCTS_ADD_PRODUCT;
}

export const profileProductsAddProduct = (
    username: string,
    productType: ProfileProductType,
    productId: number,
): ProfileProductsAddProductApiAction => ({ type: PROFILE_PRODUCTS_ADD_PRODUCT, username, productType, productId });

export interface ProfileProductsSearchProductsApiAction extends Action {
    readonly term: string;
    readonly productType: ProfileProductType;
}

export const PROFILE_PRODUCTS_SEARCH_PRODUCTS_API_REQUEST = 'PROFILE_PRODUCTS_SEARCH_PRODUCTS_API_REQUEST';

export interface ProfileProductsSearchProductsApiRequestAction
    extends ProfileProductsSearchProductsApiAction,
        APIRequestAction {
    readonly type: typeof PROFILE_PRODUCTS_SEARCH_PRODUCTS_API_REQUEST;
}

export const PROFILE_PRODUCTS_SEARCH_PRODUCTS_API_SUCCESS = 'PROFILE_PRODUCTS_SEARCH_PRODUCTS_API_SUCCESS';

export interface ProfileProductsSearchProductsApiSuccessAction extends ProfileProductsSearchProductsApiAction {
    readonly type: typeof PROFILE_PRODUCTS_SEARCH_PRODUCTS_API_SUCCESS;
    readonly options: Option[];
}

export const PROFILE_PRODUCTS_SEARCH_PRODUCTS_API_FAILURE = 'PROFILE_PRODUCTS_SEARCH_PRODUCTS_API_FAILURE';

export interface ProfileProductsSearchProductsApiFailureAction
    extends ProfileProductsSearchProductsApiAction,
        APIFailureAction {
    readonly type: typeof PROFILE_PRODUCTS_SEARCH_PRODUCTS_API_FAILURE;
}

export const profileProductsSearchProductsApi = {
    request: (productType: ProfileProductType, term: string): ProfileProductsSearchProductsApiRequestAction => ({
        type: PROFILE_PRODUCTS_SEARCH_PRODUCTS_API_REQUEST,
        term,
        productType,
    }),
    success: (
        productType: ProfileProductType,
        term: string,
        options: Option[],
    ): ProfileProductsSearchProductsApiSuccessAction => ({
        type: PROFILE_PRODUCTS_SEARCH_PRODUCTS_API_SUCCESS,
        productType,
        term,
        options,
    }),
    failure: (
        productType: ProfileProductType,
        term: string,
        error: any,
    ): ProfileProductsSearchProductsApiFailureAction => ({
        type: PROFILE_PRODUCTS_SEARCH_PRODUCTS_API_FAILURE,
        productType,
        term,
        error,
    }),
};

export const PROFILE_PRODUCTS_SEARCH_PRODUCTS = 'PROFILE_PRODUCTS_SEARCH_PRODUCTS';

export interface ProfileProductsSearchProductsAction extends ProfileProductsSearchProductsApiAction {
    readonly type: typeof PROFILE_PRODUCTS_SEARCH_PRODUCTS;
}

export const profileProductsSearchProducts = (
    productType: ProfileProductType,
    term: string,
): ProfileProductsSearchProductsAction => ({
    type: PROFILE_PRODUCTS_SEARCH_PRODUCTS,
    productType,
    term,
});
